import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, ModuleFE_Dialog, ModuleFE_Toaster, TS_Checkbox, TS_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { functionThatReturnsTrue, sleep } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
class Dialog_TestDialog extends TS_Dialog {
    // ######################## Static ########################
    static defaultProps = {
        dialogId: 'test-dialog',
    };
    static show() {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_TestDialog, {}),
            closeOverlayOnClick: functionThatReturnsTrue
        });
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.checkState ??= false;
        return state;
    }
    // ######################## Logic ########################
    toaster = (str) => {
        ModuleFE_Toaster.toastSuccess(str);
    };
    // ######################## Render ########################
    dialogLeftButtons = () => {
        return [
            {
                content: 'Delete',
                className: 'delete-button',
                onClick: () => this.toaster('Delete'),
                associatedKeys: ['Backspace']
            },
        ];
    };
    dialogRightButtons = () => {
        return [
            { content: 'Cancel', onClick: () => this.closeDialog() },
            {
                content: 'Save',
                associatedKeys: ['Enter'],
                onClick: async () => {
                    await sleep(1000);
                    this.toaster('Save');
                    console.log(this.state);
                }
            },
        ];
    };
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'header__title', children: "Test Dialog" }), _jsx(ICONS.x.component, { onClick: () => this.closeDialog() })] });
    };
    renderBody = () => {
        return _jsx(TS_Checkbox, { checked: this.state.checkState, onCheck: () => {
                this.setState({ checkState: !this.state.checkState });
            }, children: "Test" });
    };
}
class PgDev_Dialog_Class extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
    }
    render() {
        return _jsx(_Fragment, { children: _jsx(Button, { onClick: () => Dialog_TestDialog.show(), children: "Open Test Dialog" }) });
    }
}
export const PgDev_Dialog = { name: 'Dialog', key: 'dialog', renderer: PgDev_Dialog_Class };
